import { Button } from '@mui/material';
import styled from 'styled-components';
import { COLORS } from 'theme/colors';

export const StyledButton = styled(Button)<{ $primary?: boolean }>`
  background-color: ${(props) =>
    props.$primary ? `${COLORS.BLUE}` : `${COLORS.GRAY_1}`};
  color: ${(props) => (props.$primary ? 'white' : `${COLORS.GRAY_3}`)};
  font-weight: 600;
  font-size: 0.75rem;
  padding: 6px 15px;
  border-radius: 3px;

  align-self: center;

  &:disabled {
    opacity: 0.7;
    filter: grayscale(0.2);
    color: white;
  }

  &:hover {
    background-color: ${(props) =>
      props.$primary ? `${COLORS.LIGHT_BLUE}` : `${COLORS.GRAY_2}`};
  }
`;
